import React from 'react';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {useBuildingHints} from '../../../hooks/visuals/useBuildingHints';
import {MASKED_ICON_TONES, MaskedIcon} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from '../../gameUi/GameButton';

/**
 * Кнопка в шапке футера строительства: показать или спрятать описание
 * выбранного строения справа от списка (см. useBuildingHints). Нажатая —
 * описание видно, и вместо «?» стрелки внутрь: по нажатию панель станет
 * компактнее
 */
const BuildingHintsButton = () => {
  const [isHintsVisible, toggleHints] = useBuildingHints();

  const handleClick = () => {
    REGISTRY_SINGLETON.getSoundManager().playSideMenuClick();
    toggleHints();
  };

  const label = isHintsVisible ? 'Скрыть описание строения' : 'Показать описание строения';

  return (
    <GameButton
      variant={GAME_BUTTON_VARIANTS.SUNK}
      size={GAME_BUTTON_SIZES.ICON}
      pressed={isHintsVisible}
      onClick={handleClick}
      className={'footer-heading-btn building-hints-button'}
      title={label}
      aria-label={label}
    >
      <MaskedIcon
        src={isHintsVisible ? '/img/icons/compress.png' : '/img/icons/question.png'}
        alt={''}
        tone={MASKED_ICON_TONES.CONTROLS}
      />
    </GameButton>
  );
};

export default BuildingHintsButton;
